import { render, staticRenderFns } from "./recommend_news_detail.vue?vue&type=template&id=495832b3&scoped=true"
import script from "./recommend_news_detail.vue?vue&type=script&lang=js"
export * from "./recommend_news_detail.vue?vue&type=script&lang=js"
import style0 from "./recommend_news_detail.vue?vue&type=style&index=0&id=495832b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495832b3",
  null
  
)

export default component.exports